import { useEffect, useMemo, useState } from 'react';
import { SubjectSwitch } from './SubjectSwitch';
import { Box, Button, IconButton, Dialog } from '@mui/material';
import { AddOutlined, ArrowBackIos, CloseOutlined } from '@mui/icons-material';
import { useAppHomeStore, steps } from 'store/appHomeStore';
import { CollectionTitle, SerieTitle, VideoTitle } from './Title';
import { TableWithCheck } from 'components/TableWithCheck';
import { Tooltip } from 'components/Tooltip';

export const VideoOrSerieModal = ({
  count,
  listId,
  backButtonLabel,
  openButtonLabel,
  itemName,
  disabled = false,
  limitExceeded = false,
  disableGutters = false,
  fixedStep,
  inDevelopment = false,
  allowCollections = false,
}) => {
  const [open, setOpen] = useState(false);
  const [isSwitchOpen, setIsSwitchOpen] = useState(true);
  const { currentStep, setCurrentStep } = useAppHomeStore();

  useEffect(() => {
    if (fixedStep) {
      setIsSwitchOpen(false);
      setCurrentStep(fixedStep);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fixedStep]);

  const selectedData = useMemo(
    () =>
      currentStep === steps.video
        ? {
            url: '/admin/videos?status=PUBLISHED&limit=10&offset=',
            title: <VideoTitle name={itemName} />,
            listKey: 'videoList',
          }
        : currentStep === steps.collection
        ? {
            url: '/admin/collections?status=PUBLISHED&limit=10&offset=',
            title: <CollectionTitle name={itemName} />,
            listKey: 'collectionList',
          }
        : {
            url: '/admin/series?status=PUBLISHED&limit=10&offset=',
            title: <SerieTitle name={itemName} />,
            listKey: 'serieList',
          },
    [currentStep, itemName]
  );

  const closeModal = () => {
    setOpen(false);
    if (fixedStep) return;
    setTimeout(() => setIsSwitchOpen(true), 300);
  };

  const openModal = () => {
    if (inDevelopment) return alert('Funcionalidade em desenvolvimento');

    setOpen(true);
  };

  return (
    <>
      <Tooltip.Info
        title="Limite de itens alcançado"
        description="Exclua itens para adicionar mais"
        show={limitExceeded}>
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={limitExceeded ? undefined : openModal}
          data-no-dnd="true"
          sx={{
            maxWidth: 'fit-content',
            justifySelf: 'flex-end',
            margin: disableGutters ? 0 : '19px',
            marginTop: disableGutters ? 0 : 2,
            textTransform: 'none',
          }}
          startIcon={<AddOutlined />}>
          {openButtonLabel || 'Adicionar Item'}
        </Button>
      </Tooltip.Info>
      <Dialog
        fullWidth={!isSwitchOpen}
        maxWidth="calc(100% - 20px)"
        data-no-dnd="true"
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        {isSwitchOpen && (
          <IconButton
            aria-label="close modal"
            sx={{
              justifySelf: 'end',
              position: 'absolute',
              right: '10px',
              top: '10px',
            }}
            onClick={closeModal}>
            <CloseOutlined />
          </IconButton>
        )}
        {!isSwitchOpen && (
          <Button
            startIcon={<ArrowBackIos />}
            onClick={closeModal}
            sx={{
              justifySelf: 'end',
              padding: 1,
              textTransform: 'none',
              color: '#1462a5',
              fontWeight: 'bold',
              position: 'absolute',
              right: '10px',
              top: '10px',
              '& .MuiButton-startIcon': {
                margin: 0,
              },
            }}>
            {backButtonLabel || 'Voltar para Home do App'}
          </Button>
        )}
        <Box data-no-dnd="true">
          {isSwitchOpen && (
            <SubjectSwitch
              setOpen={setIsSwitchOpen}
              allowCollections={allowCollections}
            />
          )}
          {!isSwitchOpen && (
            <Box
              sx={{
                padding: 0,
                margin: 0,
                height: 'calc(100vh - 64px)',
              }}>
              <TableWithCheck
                {...selectedData}
                listId={listId}
                limitExceeded={limitExceeded}
                count={count}
              />
            </Box>
          )}
        </Box>
      </Dialog>
    </>
  );
};
